export default __webpack_public_path__ + "static/media/available_flag.62028b9c.svg";